import axios from "src/lib/axios";
import { ApiResponse } from "src/types/common";

export const getUserInfo = (): Promise<ApiResponse<any>> =>
    axios.get("/api/v1/jetCard/getUserInfo").then(res => res.data);

export const chargeUserByJetCard = (data): Promise<ApiResponse<any>> =>
    axios.post("/api/v1/jetCard/chargeUserByJetCard", data).then(res => res.data);